import { apolloClient } from "@/plugins/vue-apollo.js";

const toggleLandlordValidityPlan= (_variables) => {
  let responseFromApi;
  responseFromApi = apolloClient
    .mutate({
      mutation: require("@/settings/api/mutations/landlord_validity_plan/toggle_landlord_validity_plan_status.graphql"),
      variables: _variables,
      update: (store, { data }) => {
        const query = {
          query: require("@/settings/api/queries/landlord_validity_plan/get_all_landlord_validity_plan.graphql"),
          variables: {
            input: {
              limit: 10,
              skip: 0
            },
            filter: {
              searchKey: ''
            }
          },
        };
        store.writeQuery({
          ...query,
          data: data,
        });
      },
    })
    .catch((error) => {
      return error;
    });
  return responseFromApi;
};
export { toggleLandlordValidityPlan };
